export default {
  SET_TAGS(state, sd_sub_status) {
    state.sd_sub_status = sd_sub_status
  },
  REMOVE_TAG(state, itemId) {
      const sd_sub_statusIndex = state.sd_sub_status.datas.findIndex((u) => u.id == itemId)
      state.sd_sub_status.datas.splice(sd_sub_statusIndex, 1)
  },
  SELECTED_TAG(state,data){
    state.sd_sub_status.datas = []
    state.sd_sub_status.total = 1;
    state.sd_sub_status.per_page = 1;
    state.sd_sub_status.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.sd_sub_status = data
  },
  ADD_ITEM(state,data){
    state.sd_sub_status = data
  },
}
